import { Component } from 'react'
import { getAppDomain } from '../../store/app/selectors'
import { connect } from 'react-redux'
import {
  getGarageName,
  getGarageTitleSuffix, hasGarageCustomFavicon,
  hasGaragePDVinTitle
} from '../../store/garage/selectors'

const createLink = (head, rel, href, sizes, type) => {
  const elm = document.createElement('link');
  elm.setAttribute('rel', rel);
  elm.setAttribute('href', href);
  elm.setAttribute('sizes', sizes);
  elm.setAttribute('type', type);
  head.appendChild(elm);
}

const createMeta = (head, name, content) => {
  const elm = document.createElement('meta');
  elm.setAttribute('name', name);
  elm.setAttribute('href', content);
  head.appendChild(elm);
}


class FaviconLoader extends Component {
  componentDidMount() {
    const { domain ,titleSuffix, hasCustomFavicon, hasPDVinTitle, PDVname } = this.props;
    const head = document.getElementsByTagName('head')[0];

    const iconsBasePath = hasCustomFavicon ? `assets/icons/${domain}` : 'assets/icons/XDATA'

    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-57x57.png`, "57x57");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-60x60.png`, "60x60");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-72x72.png`, "72x72");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-76x76.png`, "76x76");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-114x114.png`, "114x114");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-120x120.png`, "120x120");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-144x144.png`, "144x144");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-152x152.png`, "152x152");
    createLink(head,"apple-touch-icon", `${iconsBasePath}/apple-icon-180x180.png`, "180x180");
    createLink(head, "icon",  `${iconsBasePath}/android-icon-192x192.png", "192x192`, "image/png");
    createLink(head, "icon",  `${iconsBasePath}/favicon-32x32.png`, "32x32", "image/png");
    createLink(head, "icon",  `${iconsBasePath}/favicon-96x96.png`, "96x96", "image/png");
    createLink(head, "icon",  `${iconsBasePath}/favicon-16x16.png`, "16x16", "image/png");
    createMeta(head, "msapplication-TileImage", `${iconsBasePath}/ms-icon-144x144.png`);
    createLink(head, "shortcut icon",  `${iconsBasePath}/favicon.ico`, "96x96", "image/png");

    if(!!titleSuffix) {
      document.title = hasPDVinTitle ? `Agenda ${titleSuffix} - ${PDVname}` : `Agenda ${titleSuffix}`
    }
  }

  render() {
    return null;
  }
}


const mapStateToProps = state => ({
  domain: getAppDomain(state),
  titleSuffix: getGarageTitleSuffix(state),
  hasCustomFavicon: hasGarageCustomFavicon(state),
  hasPDVinTitle: hasGaragePDVinTitle(state),
  PDVname: getGarageName(state)
})

export default connect(
  mapStateToProps
)(FaviconLoader)
